import './Features.css';

const features = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </svg>
    ),
    title: 'Data First',
    desc: 'Every decision backed by dashboards, not gut feel. We build the analytics infrastructure so you always know what\'s working.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
      </svg>
    ),
    title: 'Systems, Not Sprints',
    desc: 'We build automations and infrastructure that keep delivering after we leave — not one-off campaigns that stop the moment you pause spend.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
    title: 'Measurable Growth',
    desc: 'CAC, ROAS, LTV — the metrics that actually matter. We set clear targets from day one and optimise until the numbers move.',
  },
];

export default function Features() {
  return (
    <section className="feat-section">
      <div className="feat-grid">
        {features.map((f, i) => (
          <div className="feat-card" key={i}>
            <div className="feat-icon">{f.icon}</div>
            <div className="feat-body">
              <h3 className="feat-title">{f.title}</h3>
              <p className="feat-desc">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
